<template>
  <div>
    <template v-if="item !== null">
      <table
        class="prop-table"
      >
        <tr>
          <th>Product</th>
          <td>{{item.protoId | getProtoAlias}}</td>
        </tr>
        <tr>
          <th>Current amount</th>
          <td>{{item.amount}}</td>
        </tr>
      </table>

      <p class="mb-2">
        <strong>Delta</strong><br>
        <span :class="deltaClass">{{delta | getFormattedDifference}}</span>
      </p>

      <form @submit.prevent="save">
        <div class="form-group">
          <label for="newAmount">New amount</label>
          <input v-model="newAmount" id="newAmount" class="form-control" type="number" min="0" required v-focus>
        </div>

        <b-button :to="{name: 'player_inventory'}">Cancel</b-button>
        <b-button type="submit" variant="primary">Save</b-button>
      </form>
    </template>

    <loading-indicator
      v-if="isLoading"
    />

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';
import { getDeltaClass } from '../util.js';

/**
 * @typedef { import("../model/player_inventory.js").InventoryItem } InventoryItem
 */

import LoadingIndicator from './LoadingIndicator.vue';

export default {
  name: 'PlayerInventoryItemEdit',

  components: {
    LoadingIndicator,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    itemId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,

      /** @type {?InventoryItem} */
      item: null,

      /** @type {?number} */
      newAmount: null,

      isSaving: false,
    };
  },

  computed: {
    /** @returns {number} */
    delta() {
      if(this.item === null) {
        return 0;
      }
      if(this.newAmount === null) {
        return 0;
      }
      return this.newAmount - this.item.amount;
    },

    /** @returns {Object} */
    deltaClass() {
      return getDeltaClass(this.delta);
    },
  },

  created() {
    this.loadInventoryItem();
  },

  methods: {
    loadInventoryItem() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      const url = `/player/${this.playerId}/inventory/item/${this.itemId}`;
      HTTP.get(url)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.');
          return;
        }

        const item = data;
        this.newAmount = item.amount;
        this.item = item;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    save() {
      if(this.isSaving) {
        return;
      }

      this.isSaving = true;
      notifier.deleteSenderNotifications(this);

      const data = new FormData();
      data.append('amount', this.newAmount);

      const url = `/player/${this.playerId}/inventory/item/${this.itemId}/amount`;
      HTTP.post(url, data)
      .then(() => {
        this.isSaving = false;
        notifier.showSuccessAfterTransition('Changes saved.');
        this.$router.push({name: 'player_inventory'});
      })
      .catch(e => {
        this.isSaving = false;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>

<style scoped>
.prop-table {
  margin-bottom: 1rem;
}

label {
  font-weight: bold;
}
</style>
